import React from 'react';
import PropTypes from 'prop-types';
import { Inline as LabelInline } from '../Label';
import { Checkbox as BoneyardCheckbox, Box } from '../Boneyard';
import getNamespacedFieldName from './getNamespacedFieldName';
import getFormPartAutomationHook from './getFormPartAutomationHook';
import FieldHandler from './FieldHandler';
import styled from 'styled-components';
import CallCenterIcon from '../../images/ic-call-center.svg';

const propTypes = {
  name: PropTypes.string.isRequired,
  namespace: PropTypes.string,
  label: PropTypes.string,
  isRequired: PropTypes.bool,
  automationHook: PropTypes.string,
  isNested: PropTypes.bool,
  labelSize: PropTypes.number,
  boldLabel: PropTypes.bool,
  onChange: PropTypes.func,
  fieldLevelValidation: PropTypes.func,
  iconAlignment: PropTypes.string,
  autoSelectedDefaultValue: PropTypes.bool,
  displayIcon: PropTypes.bool,
  // ... plus other Boneyard Checkbox fields
};
const defaultProps = {
  isNested: false,
  onChange: Function.prototype,
};
const Checkbox = React.memo(
  ({
    namespace,
    isRequired,
    label,
    name,
    automationHook,
    isNested,
    labelSize = 14,
    boldLabel = false,
    onChange,
    fieldLevelValidation,
    iconAlignment,
    displayIcon,
    autoSelectedDefaultValue = false,
    ...props
  }) => {
    const fieldName = getNamespacedFieldName(name, namespace);

    const StyledIcon = styled.img`
      height: 20px;
      width: 20px;
    `;

    const fieldAutomationHook = getFormPartAutomationHook(
      automationHook,
      name,
      namespace
    );

    return (
      <Box d={'flex'} pt={isNested ? 1 : 2}>
        <FieldHandler
          id={fieldName}
          name={fieldName}
          fieldLevelValidation={fieldLevelValidation}
          onChange={onChange}
        >
          <BoneyardCheckbox
            autoSelectedDefaultValue={autoSelectedDefaultValue}
            {...props}
            name={fieldName}
            automationHook={fieldAutomationHook}
            label={fieldName}
            layout={'inline-icon-center'}
            isNested={isNested}
            iconAlignment={iconAlignment}
          >
            {label && (
              <LabelInline
                htmlFor={fieldName}
                isRequired={isRequired}
                size={labelSize}
                bold={boldLabel}
                automationHook={fieldAutomationHook}
              >
                {label}
              </LabelInline>
            )}
          </BoneyardCheckbox>
          {displayIcon && <StyledIcon src={CallCenterIcon} alt="" />}
        </FieldHandler>
      </Box>
    );
  }
);
Checkbox.propTypes = propTypes;
Checkbox.defaultProps = defaultProps;

export default Checkbox;
